import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  username: string = '';

  ngOnInit(): void {
    const storedUser = localStorage.getItem('userName');
    this.username = storedUser ? storedUser.toUpperCase() : 'Guest';
  }
}
